import { ArrowDown, ArrowUp } from "lucide-react"
import { cn } from "@/lib/utils"

/** "↑ 9%" in green, "↓ 4%" in red; a dash when there is nothing to compare with. */
export default function Delta({ pct }: { pct: number | null }) {
  if (pct == null) return <span className="text-muted-foreground">–</span>

  const up = pct >= 0
  const Icon = up ? ArrowUp : ArrowDown
  return (
    <span className={cn("inline-flex items-center gap-0.5 font-medium tabular-nums", up ? "text-success" : "text-destructive")}>
      <Icon size={12} />
      {Math.abs(pct)}%
    </span>
  )
}
